<template lang="pug">
.password-strength-meter(:class="{ mounted }")
  .password-strength-meter--fill(:data-score="score")
</template>

<script>
import AuthApi from '@/extensions/restricted-area/store/api/auth';
import { debounce } from '@/helpers';

export default {
  name: 'PasswordStrengthMeter',
  props: {
    /**
     * Binded password
     * @type {Object}
     */
    password: {
      type: String
    },

    /**
     * @type String
     */
    user: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    mounted: false,
    result: undefined
  }),

  watch: {
    password: debounce(function(password) {
      if (password) {
        AuthApi.getPasswordStrength(password).then(result => (this.result = result));
      } else {
        this.result = undefined;
      }
    }, 150),
    score(score) {
      this.$emit('score', score);
    },
    feedback(feedback) {
      this.$emit('feedback', feedback || {});
    }
  },

  computed: {
    /**
     * score calculated by zxcvbn
     * @return {Number} Password Strength Score
     */
    score() {
      return this.result ? this.result.score : null;
    },

    /**
     * feedback defined by zxcvbn
     * @return {Object} Password Strength Feedback
     */
    feedback() {
      return this.result ? this.result.feedback : null;
    }
  },

  mounted() {
    if (this.password) {
      AuthApi.getPasswordStrength(this.password)
        .then(result => (this.result = result))
        .finally(() => (this.mounted = true));
    } else {
      this.result = undefined;
      this.mounted = true;
    }
  }
};
</script>

<style lang="sass">
.password-strength-meter
  position: relative
  height: 4px
  background: rgba(0, 0, 0, .15)
  margin: 5px auto 0
  border-radius: 3px

  &:before, &:after
    content: ''
    height: inherit
    background: transparent
    display: block
    border-color: #fff
    border-style: solid
    // border-width: 0 2px 0 2px
    position: absolute
    width: 20%
    z-index: 10

  &:before
    left: 20%

  &:after
    right: 20%

  &.mounted .password-strength-meter--fill
    transition: width 0.5s ease-in-out, background 0.25s

  .password-strength-meter--fill
    background: transparent
    height: inherit
    position: absolute
    width: 0
    border-radius: inherit

    &[data-score='0']
      background: darkred
      @apply bg-red-600
      width: 20%

    &[data-score='1']
      background: orangered
      @apply bg-orange-600
      width: 40%

    &[data-score='2']
      background: orange
      @apply bg-amber-500
      width: 60%

    &[data-score='3']
      background: yellowgreen
      @apply bg-lime-500
      width: 80%

    &[data-score='4']
      background: green
      @apply bg-cyan-500
      width: 100%
</style>
